import { createSlice } from '@reduxjs/toolkit';
import {
  fetchClientJourneyById,
  createClientJourney,
  updateClientJourney,
  deleteClientJourney,
  updateClientJourneyProgress
} from '../thunks/clientJourneyThunk';

const clientJourneySlice = createSlice({
  name: 'clientJourney',
  initialState: {
    currentJourney: null,
    status: 'idle',
    error: null
  },
  reducers: {
    clearCurrentJourney: (state) => {
      state.currentJourney = null;
      state.status = 'idle';
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch Journey
      .addCase(fetchClientJourneyById.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchClientJourneyById.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.currentJourney = action.payload;
        state.error = null;
      })
      .addCase(fetchClientJourneyById.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
        state.currentJourney = null;
      })
      // Create Journey
      .addCase(createClientJourney.fulfilled, (state, action) => {
        state.currentJourney = action.payload;
        state.status = 'succeeded';
        state.error = null;
      })
      // Update Journey
      .addCase(updateClientJourney.fulfilled, (state, action) => {
        state.currentJourney = action.payload;
        state.status = 'succeeded';
        state.error = null;
      })
      // Delete Journey
      .addCase(deleteClientJourney.fulfilled, (state) => {
        state.currentJourney = null;
        state.status = 'succeeded';
        state.error = null;
      })
      // Update Journey Progress
      .addCase(updateClientJourneyProgress.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(updateClientJourneyProgress.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.currentJourney = action.payload;
        state.error = null;
      })
      .addCase(updateClientJourneyProgress.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  }
});

export const { clearCurrentJourney } = clientJourneySlice.actions;
export default clientJourneySlice.reducer;